export const STATUS_COLORS = {
  PENDING: { bg: '#FFF4E6', text: '#E65100' },
  CONFIRMED: { bg: '#E3F2FD', text: '#1565C0' },
  PENDING_SAMSUNG: { bg: '#FFE0B2', text: '#E65100' },
  AWAITING_DELIVERY: { bg: '#E1BEE7', text: '#7B1FA2' },
  IN_FULFILLMENT: { bg: '#F3E5F5', text: '#6A1B9A' },
  PARTIALLY_FULFILLED: { bg: '#F3E5F5', text: '#7B1FA2' },
  FULFILLED: { bg: '#E8F5E9', text: '#2E7D32' },
  PARTIALLY_INVOICED: { bg: '#FFF9C4', text: '#F57F17' },
  INVOICED: { bg: '#E8F5E9', text: '#388E3C' },
  COMPLETED: { bg: '#E0F2F1', text: '#00695C' },
  CANCELED: { bg: '#FFEBEE', text: '#C62828' },
};

export const STATUS_LABELS = {
  PENDING: 'Pendente',
  CONFIRMED: 'Confirmado',
  PENDING_SAMSUNG: 'Pendência Samsung',
  AWAITING_DELIVERY: 'Aguardando Entrega',
  IN_FULFILLMENT: 'Em Atendimento',
  PARTIALLY_FULFILLED: 'Parcialmente Atendido',
  FULFILLED: 'Atendido',
  PARTIALLY_INVOICED: 'Parcialmente Faturado',
  INVOICED: 'Faturado',
  COMPLETED: 'Concluído',
  CANCELED: 'Cancelado',
};

export const ORDER_STEPS = [
  'Selecionar Cliente',
  'Adicionar Produtos',
  'Definir Valores',
  'Revisar Pedido',
];
